import { render } from "./RequestView.vue?vue&type=template&id=3b7e13dc&scoped=true"
import script from "./RequestView.vue?vue&type=script&lang=js"
export * from "./RequestView.vue?vue&type=script&lang=js"

import "./RequestView.vue?vue&type=style&index=0&id=3b7e13dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7e13dc"]])

export default __exports__